import LightDarkHeader from "./LightDarkHeader";
import SecondHeader from "../SecondHeader";
import Header from "../Header";
import { useSelector } from "react-redux";
import IconsHeader from "./IconsHeader";
// import TransparentHeader from "./TransparentHeader";
import CenterHeader from "./CenterHeader";
import BoxedHeader from "./BoxedHeader";

function HeaderWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_header === "centered-menu-header" ? (
        <SecondHeader />
      ) : sitedata?.theme_header === "dark-header" ? (
        <LightDarkHeader />
      ) : sitedata?.theme_header === "icon-header" ? (
        <IconsHeader />
      ) : sitedata?.theme_header === "header-center" ? (
        <CenterHeader />
      ) : sitedata?.theme_header === "boxed-header" ? (
        <BoxedHeader />
      ) : (
        <Header />
      )}
      {/* <TransparentHeader /> */}
    </>
  );
}

export default HeaderWrapper;
